import { render } from "./ViewMediaMoreAudio.vue?vue&type=template&id=68be136c&scoped=true"
import script from "./ViewMediaMoreAudio.vue?vue&type=script&lang=js"
export * from "./ViewMediaMoreAudio.vue?vue&type=script&lang=js"

import "./ViewMediaMoreAudio.vue?vue&type=style&index=0&id=68be136c&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-68be136c"

export default script